import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/search.vue'),
  },
  {
    path: '/products',
    name: 'products',
    component: () => import('@/views/products.vue'),
  },
  {
    path: '/products-list',
    name: 'products-list',
    component: () => import('@/views/products-list.vue'),
  },
  {
    path: '/users',
    name: 'users',
    component: () => import('@/views/users.vue'),
  },
  {
    path: '/orders',
    name: 'orders',
    component: () => import('@/views/orders.vue'),
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/logout.vue'),
  },
  {
    path: '/user-area',
    name: 'user-area',
    component: () => import('@/views/user-area.vue'),
  },
  {
    path: '/reset-password/:token',
    name: 'reset-password',
    component: () => import('@/views/reset-password.vue'),
  },

]

const router = new VueRouter({
  routes
})

export default router
